import { useContext } from "react";

import classes from "./IngredientBarBasic.module.css";

import SearchContext from "../../../store/search-context";

// component containing the name of an ingredient and the ability to add the ingredient to the search bar
const IngredientBarBasic = (props) => {
  const searchCtx = useContext(SearchContext);

  // add ingredient to the search bar
  const addItemHandler = () => {
    searchCtx.addItem(props.ingredient);
  };

  return (
    <div className={classes.ingredient_bar} onClick={addItemHandler}>
      {props.ingredient.title}
    </div>
  );
};

export default IngredientBarBasic;
